import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NtCompany } from '../../../shared/models/nt-company';
import { DialogService } from '../../../shared/services/dialog.service';

@Component({
  selector: 'app-import-items-base',
  templateUrl: './import-items-base.component.html',
  styleUrls: ['./import-items-base.component.scss']
})
export class ImportItemsBaseComponent implements OnInit {
    @Output() companyAvailable = new EventEmitter<NtCompany>();
    @Output() uploadFileEvent = new EventEmitter<any>();

    @Input() phase1 = true;
    @Input() title = ''
    @Input() error = false;
    @Input() errorMessage = '';

    extensions = ['xls', 'xlsx'];
    types = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];


    constructor(private dlg: DialogService) { }

    ngOnInit(): void {
    }

    companyAvailableHandler(c: NtCompany){
        this.companyAvailable.emit(c);
    }

    onFileSelected(){
        const inputNode: any = document.querySelector('#file');
        let files = inputNode.files;
        if (files.length > 0) {
            //Add some validation to the type of file.  Examine the mime type.
            let f = files[0];
            let xtn = f.name.substring(f.name.lastIndexOf('.') + 1, f.name.length) || f.name;
            console.log("File extension: " + xtn);
            console.log("File mime type: " + f.type);

            if (!f.type) {
                if (this.extensions.indexOf(xtn) > -1) {
                    console.log("Found " + xtn + " in extension list");
                    this.uploadFile(f);
                } else {
                    console.log("did not find " + xtn + " in extension list");
                    this.dlg.showOk("Upload asset file", "Only XLS or XLSX files can be imported.  Please retry with a different file format");
                }
            } else {
                if (this.types.indexOf(f.type) > -1) {
                    console.log("Found " + f.type + "in mime type list");
                    this.uploadFile(f);
                } else {
                //Fall back on extension check?
                    if (this.extensions.indexOf(xtn) > -1) {
                        console.log("Failed mime check but passed extension check");
                        this.uploadFile(f);
                    } else {
                        this.dlg.showOk("Upload asset file", "The file you have uploaded is not recognised as an excel spreadsheet file.  Please recheck your file and try again.");
                    }
                }
            }
        }
    }

    async uploadFile(file: any){
        this.uploadFileEvent.emit(file);
    }

}
